import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { PageComponent } from "@components/page/page.component";
import { SaveButtonComponent } from "@components/save-button/save-button.component";
import { from } from "rxjs";
import { BusyService } from "~app/common/components/busy/busy.service";
import { FeatureSettingUserDTO } from "~app/common/models/featureSetting/FeatureSettingUserDTO";
import { AnvandareService } from "~app/common/services/anvandare.service";
import { CommandService } from "~app/common/services/cqs/command.service";
import { CommandManager } from "~app/common/services/cqs/commandManager";
import { FeatureService } from "~app/common/services/feature.service";
import { SystemadministrationService } from "~app/features/administration/systemadministration/systemadministration.service";
import { UpdateClientFeatureCommand } from "./UpdateClientFeatureCommand";

@Component({
    selector: "rask-funktioner",
    templateUrl: "./funktioner.component.html",
    styleUrls: ["./funktioner.component.scss"],
    providers: [CommandManager],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        BlockComponent,
        HeaderComponent,
        CheckboxComponent,
        FormsModule,
        SaveButtonComponent
    ]
})
export class FunktionerComponent implements OnInit {
    currentUserFeatures: FeatureSettingUserDTO[];
    userId: number;

    private readonly administrationService = inject(SystemadministrationService);
    private readonly anvandareService = inject(AnvandareService);
    private readonly busyService = inject(BusyService);
    private readonly commandManager = inject(CommandManager);
    private readonly commandService = inject(CommandService);
    private readonly featureService = inject(FeatureService);

    canEdit(feature: FeatureSettingUserDTO): boolean {
        return feature.editableForEndUser;
    }

    canSave() {
        return this.commandManager.isDirty();
    }

    init(): void {
        this.administrationService.loadUserFeatureSettings()
            .subscribe(list => {
                this.currentUserFeatures = list;
            });

        this.anvandareService.getCurrentUserId().subscribe(userId => {
            this.userId = userId;
        });
    }

    ngOnInit(): void {
        this.init();
    }

    onCheckedChange() {
        this.commandManager.addOrUpdate(new UpdateClientFeatureCommand(c => {
            c.userId = this.userId;
            c.featureIds = this.currentUserFeatures.filter(x => x.selected).map(y => y.id);
        })
        ,
        (c) => c.$type === UpdateClientFeatureCommand.$type &&
                    c.userId === this.userId);
    }

    save() {
        const work = from(this.commandService.pushCommands(this.commandManager));
        this.busyService.addWork(work)
            .subscribe(() => {
                this.commandManager.clear();
                this.featureService.refreshClientFeatures();
                this.init();
            });
    }
}
